import { render } from "./LegalMentionsPage.vue?vue&type=template&id=47a952a2"
import script from "./LegalMentionsPage.vue?vue&type=script&lang=js"
export * from "./LegalMentionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__